/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isFetching: false,
  socketStatus: '',
  error: null,
  isClosedSockets: false,
  isOpenedSockets: false,
  waiting: false,
};

const wsSlice = createSlice({
  name: 'ws',
  initialState,
  reducers: {
    startFetching: state => ({
      ...state,
      isFetching: true,
    }),
    stopFetching: state => ({
      ...state,
      isFetching: false,
    }),
    setSocketsStatus: (state, action) => ({
      ...state,
      socketStatus: action.payload,
    }),
    setClosedSockets: (state, action) => ({
      ...state,
      isClosedSockets: action.payload,
    }),
    setOpenedSockets: (state, action) => ({
      ...state,
      isOpenedSockets: action.payload,
    }),
    setSocketError: (state, action) => {
      state.error = action.payload;
    },
    clearSocketError: (state) => {
      state.error = null;
    },
    startWaiting(state) {
      state.waiting = true;
    },
    stopWaiting(state) {
      state.waiting = false;
    },
  },

  // INJECT

});

export default wsSlice;
